// Side-effect module: importing it installs the fix once.
//
// Quiets the benign "ResizeObserver loop ... undelivered notifications" error
// that CRA's dev overlay pops on. The loop comes from Cloudscape's own
// ResizeObserver callbacks and is harmless. A global 'error' listener swallows
// just that one message so the overlay stays closed — no need to patch the
// global ResizeObserver itself (wrapping its callback in requestAnimationFrame
// changes dev/prod timing and can fire after a component disconnects).
//
// DEVELOPMENT-ONLY: this warning only surfaces in CRA's dev overlay, so the
// listener is gated to `NODE_ENV === 'development'` and compiled out of
// production builds. It is imported once at the app entry point (index.js) so
// it covers every page with a fully-populated Cloudscape table.

if (process.env.NODE_ENV === 'development' && typeof window !== 'undefined') {
  const RESIZE_OBSERVER_ERR = /ResizeObserver loop (limit exceeded|completed with undelivered notifications)/;
  window.addEventListener('error', (e) => {
    if (e.message && RESIZE_OBSERVER_ERR.test(e.message)) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  });
}
